import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getExamResults} from '../../services/getExamResults';
import {GetExamResultsParams} from '../../services/getExamResults/types';

export const useGetExamResultsQuery = (params: GetExamResultsParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.EXAM_RESULTS, params],
		queryFn: ({signal}) => getExamResults({...params, signal}),
	});
